/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import React, { FC, ReactElement, CSSProperties, PropsWithChildren } from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

export interface IProps {
  id: string;
  overlay: string | ReactElement;
  placement?: 'top' | 'bottom' | 'left' | 'right';
  show?: boolean;
  wrapperClass?: string;
  style?: CSSProperties;
}

const TooltipWrapper: FC<PropsWithChildren<IProps>> = ({
  id,
  overlay,
  placement = 'top',
  children,
  show,
  wrapperClass = '',
  style = {},
}: PropsWithChildren<IProps>) => {
  return (
    <OverlayTrigger
      placement={placement}
      overlay={<Tooltip id={id}>{overlay}</Tooltip>}
      show={show}
    >
      <span
        className={`d-inline-block ${wrapperClass}`}
        tabIndex={0}
        style={style}
      >
        {children}
      </span>
    </OverlayTrigger>
  );
};

export default TooltipWrapper;
